
const { v4: uuidv4 } = require('uuid')

export default function uuid() {
    return uuidv4()
}


